import React from 'react';
import styled from '@emotion/styled-base';

interface WrapParams {
  width: number;
  height: number;
  weight: number;
  delay: number;
  rotate: number;
}

const Wrapper = styled('div')<WrapParams>`
  position: relative;
  width: ${p => p.width + p.weight}px;
  height: ${p => p.height + p.weight}px;
  transform: rotate(${p => p.rotate}deg);
  transform-origin: 50% 50%;
  transition: transform 0.2s;
  ${p => p.delay && `transition-delay: ${p => p.delay}s;`}
`;

interface LineProps {
  color: string;
  weight: number;
}

const Line = styled('polyline')<LineProps>`
  fill: none;
  stroke: ${p => p.color};
  stroke-width: ${p => p.weight};
  stroke-linejoin: miter;
  stroke-miterlimit: 10;
  transform: translateY(${p => p.weight / 4}px) scale(0.8);
  transform-origin: 50% 50%;
`;

const Arrow = ({
  className = '',
  color = '#fff',
  height = 16,
  rotate = 0,
  delay = 0,
  weight = 2,
  width = 8,
  onClick = () => {},
}) => {
  return (
    <Wrapper
      height={height}
      width={width}
      rotate={rotate}
      weight={weight}
      delay={delay}
    >
      <svg width="100%" height="100%">
        <Line
          points={`0,0 ${width},${height / 2} 0,${height}`}
          weight={weight}
          color={color}
        />
      </svg>
    </Wrapper>
  );
};

export default Arrow;
